import { MeetingParticipants } from "./MeetingParticipants";
import { MeetingPoints } from "./MeetingPoints";
import { STab, STabList, STabPanel, STabs } from "../../styles/Tabs";
import { StyledUnitBody } from "../../styles/StyledUnit";
import PropTypes from "prop-types";

export default function MeetingBody({ newMeeting, refetch, id }) {
	return (
		<StyledUnitBody sm={12}>
			<STabs selectedTabClassName="is-selected" selectedTabPanelClassName="is-selected">
				<STabList className={newMeeting ? "disabled" : ""}>
					<STab disabled={newMeeting}>Agenda</STab>
					<STab disabled={newMeeting}>Participants</STab>
				</STabList>
				<STabPanel className={newMeeting ? "disabled" : ""}>{!newMeeting && <MeetingPoints id={id} />}</STabPanel>
				<STabPanel className={newMeeting ? "disabled" : ""}>
					<MeetingParticipants refetch={refetch} />
				</STabPanel>
			</STabs>
		</StyledUnitBody>
	);
}

MeetingBody.propTypes = {
	newMeeting: PropTypes.bool,
	id: PropTypes.string,
	edit: PropTypes.bool,
	refetch: PropTypes.func,
	upperUnitId: PropTypes.any,
};
